




import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GLink',
  props: {
    href: {
      type: String as PropType<string>,
      default: '',
    },
    blank: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    ignoreCurrentEx: {
      type: Boolean as PropType<boolean>,
      default: false,
      required: false,
    },
  },
  computed: {
    url(): string {
      if (this.ignoreCurrentEx) {
        return this.href;
      }
      if (!this.$route.query || !this.$route.query.ex) {
        return this.$router.resolve({
          path: this.href,
        }).href;
      } else {
        return this.$router.resolve({
          path: this.href,
          query: {
            ex: this.$route.query.ex,
          },
        }).href;
      }
    },
  },
});
